import React from 'react'
import { Button } from 'b3'
import { connect } from 'react-redux'
import UserAvatar from '../components/UserAvatar'

@connect(state => ({
    theme: state.theme,
    authUser: state.auth.user,
}))
export default class MySettings extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showLink: false,
        }
    }
    toggleShowLink() {
        this.setState({
            showLink: !this.state.showLink,
        })
    }

    changeColour = (key, colour) =>
        this.props.dispatch({ type: `CHANGE_${key}`, colour })

    render() {
        var { authUser, theme } = this.props

        return (
            <div>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h2>Profile Picture</h2>
                    </div>
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-md-1">
                                <a
                                    target="_blank"
                                    href="https://en.gravatar.com/"
                                >
                                    <UserAvatar user={authUser} size={60} />
                                </a>
                            </div>
                            <div className="col-md-11">
                                <p>
                                    To change your profile picture, create an
                                    account at{' '}
                                    <a
                                        target="_blank"
                                        href="https://en.gravatar.com/"
                                    >
                                        Gravatar
                                    </a>{' '}
                                    and upload your picture against your email:{' '}
                                    <strong>{authUser.email}</strong>.
                                </p>
                                <br />
                                <a
                                    target="_blank"
                                    href="https://en.gravatar.com/"
                                >
                                    https://en.gravatar.com/
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h2>Candy Theme</h2>
                    </div>
                    <div className="panel-body">
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                flexWrap: 'wrap'
                            }}
                        >
                            {theme.themes.map((t, i) => (
                                <div style={{ display: 'flex', marginBottom: '0.3em' }}>
                                    {t.values.map(v => (
                                        <div style={{ background: v.default }}>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </div>
                                    ))}
                                    <Button
                                        key={t.key}
                                        onClick={() =>
                                            this.props.dispatch({
                                                type: 'SELECT_THEME',
                                                theme: i,
                                            })
                                        }
                                    >
                                        {t.name}
                                    </Button>
                                </div>
                            ))}
                        </div>
                        <h2>Customise</h2>
                        <table>
                            <tbody>
                                {Object.values(theme.selected).map(t => (
                                    <tr key={t.key}>
                                        <td style={{paddingRight: '10px'}}>{t.description} colour</td>
                                        <td>
                                            <input
                                                type="color"
                                                onChange={e =>
                                                    this.changeColour(
                                                        t.key,
                                                        e.target.value
                                                    )
                                                }
                                                value={t.value}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/pages/MySettings.js